import type { BaseEmoji } from 'emoji-mart';
import { useTranslation } from 'react-i18next';
import { Popover, PopoverPanel } from '@/components/Popover';
import { useIsMobileBreakpoint } from '@/hooks/useIsBreakpoint';
import { EmojiSelect } from '@/pages/Schedule/components';
import { type BoxProps, useDisclosure } from '@/ui';
import { EmojiButton } from './EmojiButton';

type Props = Omit<BoxProps, 'onClick' | 'onSelect'> & {
  value?: string | null;
  onSelect: (emoji: string | null) => void;
};

export const EmojiSheet = ({ value, onSelect, ...props }: Props) => {
  const { isOpen, onOpen, onClose } = useDisclosure();
  const { t } = useTranslation('entryModal');
  const isMobile = useIsMobileBreakpoint();

  const trigger = (
    <EmojiButton
      value={value}
      onClick={onOpen}
      onRemoveClick={(event) => {
        event.stopPropagation();
        onSelect(null);
      }}
      {...props}
    />
  );

  return (
    <Popover
      isOpen={isOpen}
      offset={[0, 8]}
      trigger={trigger}
      onClose={onClose}
    >
      <PopoverPanel
        panelProps={{ maxH: 'auto', px: [4, 4, 4, 0] }}
        title={isMobile && t('emoji.sheet_title')}
      >
        <EmojiSelect
          style={{ width: '100%' }}
          onSelect={(emoji: BaseEmoji) => {
            onSelect(emoji.native);
            onClose();
          }}
        />
      </PopoverPanel>
    </Popover>
  );
};
